import { ProductStockInfo } from "./productTypes"

export function getMaxQuantity(stock: ProductStockInfo | undefined): number | undefined {
    const limits: number[] = []

    const daily = stock?.sales?.daily
    if (daily?.itemsForSale) limits.push(daily.remaining)

    const inventoryAvailable = stock?.inventory?.available
    if (inventoryAvailable !== undefined) limits.push(inventoryAvailable)

    return limits.length > 0 ? Math.min(...limits) : undefined
}

export function getProductLeftCount(stock: ProductStockInfo | undefined): number | undefined {
    const daily = stock?.sales?.daily
    if (!daily || !daily.itemsForSale) return undefined
    return daily.remaining
}
